<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="common-label">
              Do you have an Employer Matching Contribution?
            </div>
          </div>
          <div class="form-unit">
            <roe-employer-match-select :design="$v.formData">
            </roe-employer-match-select>
          </div>
          <div class="form-unit"></div>
        </div>

        <template v-if="showForm(formData)">
          <div
            v-show="
              +formData.plan_has_employer_matching_contributions_picklist_id ===
                2
            "
            class="form-row form-row--center-full"
          >
            <div class="form-unit">
              <div class="common-label">
                Please answer the following questions regarding the Employer
                Matching Contribution for the PRIMARY group of employees covered
                by this plan
              </div>
            </div>
            <div class="form-unit"></div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="common-label">
                Does the plan have an age requirement for Employer Matching
                Contributions?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-age-requirement-select :design="$v.formData">
              </roe-employer-match-age-requirement-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row" v-if="showAgeRequirement(formData)">
            <div class="form-unit">
              <div class="light-label">
                Age Requirement for
                <template v-if="+formData.age_requirement_employer_match === 3">
                  the primary group of employees covered by
                </template>
                the plan
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-age-requirement-years-input
                :design="$v.formData"
              >
              </roe-employer-match-age-requirement-years-input>
              <div class="input-devider"></div>
              <roe-employer-match-age-requirement-months-input
                :design="$v.formData"
              >
              </roe-employer-match-age-requirement-months-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="common-label">
                Does the plan have a service requirement for Employer Matching
                Contributions?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-service-requirement-select
                :design="$v.formData"
              >
              </roe-employer-match-service-requirement-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row" v-if="showServiceRequirement(formData)">
            <div class="form-unit">
              <div class="light-label">
                Service Requirement for
                <template
                  v-if="+formData.service_requirement_employer_match === 3"
                >
                  the primary group of employees covered by
                </template>
                the plan
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-service-requirement-months-input
                :design="$v.formData"
                class="input-wrap--small"
              ></roe-employer-match-service-requirement-months-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="common-label">
                Is the Employer Matching Contribution fixed each year or can it
                vary from year to year?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-type-select :design="$v.formData">
              </roe-employer-match-type-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="common-label">
                Please provide the type of Employer Matching Contribution
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-contribution-type-select
                :design="$v.formData"
              >
              </roe-employer-match-contribution-type-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                Funding Frequency
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-funding-frequency-select
                :design="$v.formData"
              >
              </roe-employer-match-funding-frequency-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                Post Tax Contributions
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-post-tax-contributions-radio
                :design="$v.formData"
              >
              </roe-employer-match-post-tax-contributions-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                Does the Employer Matching Contribution vary from Year to Year?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-contrib-based-yos-radio :design="$v.formData">
              </roe-employer-match-contrib-based-yos-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="light-label">
                Does the Employer Matching Contribution vary based on EE Years
                of Service?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-yos-vary-ee-radio :design="$v.formData">
              </roe-employer-match-yos-vary-ee-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="common-label">
                Please indicate the number of tiers in your Employer Matching
                Contribution
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-number-tiers-select :design="$v.formData">
              </roe-employer-match-number-tiers-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div
            class="form-row form-row--center-small-last-small"
            v-if="showTierInputs(formData)"
          >
            <div class="form-unit">
              <div class="light-label">
                Employer Matching Contribution Formula
              </div>
            </div>
            <div class="form-unit">
              <div class="input-wrap">
                <div class="light-label">Matching Amount</div>
              </div>
              <div class="input-devider"></div>
              <div class="input-wrap">
                <div class="light-label" v-if="showTierDeferralRate(formData)">
                  Compensation
                </div>
                <div
                  class="light-label"
                  v-if="showTierContributionAmount(formData)"
                >
                  Contributions
                </div>
              </div>
            </div>
            <div class="form-unit" v-if="showTierApplicableYear(formData)">
              <div class="input-wrap">
                <div class="light-label">Applicable Year</div>
              </div>
            </div>
            <div class="form-unit">
              <div class="input-wrap" v-if="showTierYosUpperLimit(formData)">
                <div class="light-label">Years of Service</div>
              </div>
            </div>
          </div>

          <div
            v-for="(tier, index) in $v.formData.tiers.$each.$iter"
            class="form-row form-row--center-small-last-small"
          >
            <div class="form-unit">
              <div class="light-label">Tier {{ +index + 1 }}</div>
            </div>
            <div class="form-unit">
              <roe-tier-matching-amount-input :tier="tier">
              </roe-tier-matching-amount-input>
              <div class="input-devider"></div>
              <roe-tier-deferral-rate-input
                :tier="tier"
                :is-deferral-rate="showTierDeferralRate(formData)"
              ></roe-tier-deferral-rate-input>
              <roe-tier-contribution-amount-input
                :tier="tier"
                :is-contribution-amount="showTierContributionAmount(formData)"
              ></roe-tier-contribution-amount-input>
            </div>
            <div class="form-unit" v-if="showTierApplicableYear(formData)">
              <roe-tier-applicable-year-input
                :tier="tier"
                :value="new Date().getFullYear() + +index"
              ></roe-tier-applicable-year-input>
            </div>
            <roe-tier-yos-upper-limit-input
              v-if="showTierYosUpperLimit(formData)"
              :tier="tier"
              :tiers="formData.tiers"
              :index="+index"
            >
            </roe-tier-yos-upper-limit-input>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row" v-if="showDollarLimit(formData)">
            <div class="form-unit">
              <div class="common-label">
                Is there a dollar limit for Employer Matching Contributions?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-dollar-limit-radio
                :design="$v.formData"
              ></roe-employer-match-dollar-limit-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row" v-if="showDollarLimitAmount(formData)">
            <div class="form-unit">
              <div class="light-label">
                Indicate the Maximum Employer Matching Contribution an employee
                can receive
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-dollar-amount-input
                :design="$v.formData"
              ></roe-employer-match-dollar-amount-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="common-label">
                Hire Date For Employer Match
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-hire-date-input
                :design="$v.formData"
              ></roe-employer-match-hire-date-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="main-label">
                Other questions about Employer Matching Contributions
              </div>
            </div>
            <div class="form-unit"></div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Catch-Up Contributions Matched</div>
            </div>
            <div class="form-unit">
              <roe-employer-match-catch-up-radio
                :design="$v.formData"
              ></roe-employer-match-catch-up-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">True-Up Performed</div>
            </div>
            <div class="form-unit">
              <roe-employer-match-true-up-calculate-radio
                :design="$v.formData"
              ></roe-employer-match-true-up-calculate-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row" v-if="showFrequency(formData)">
            <div class="form-unit">
              <div class="light-label">
                Indicate how often True-Up Calculations are performed
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-true-up-frequency-select
                :design="$v.formData"
              ></roe-employer-match-true-up-frequency-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                End-of-Year (EOY) requirement applies
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-e-o-y-requirement-radio
                :design="$v.formData"
              ></roe-employer-match-e-o-y-requirement-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                Plan Year Service Requirement applies
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-match-service-req-applies-select
                :design="$v.formData"
              ></roe-employer-match-service-req-applies-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row" v-if="showHoursOrMonths(formData)">
            <div class="form-unit">
              <div class="light-label">Plan Year Service Requirement</div>
            </div>
            <div class="form-unit">
              <roe-employer-match-service-req-applies-input
                :design="$v.formData"
              ></roe-employer-match-service-req-applies-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="main-label">
                Indicate if the definition of compensation for deferrals that
                can be matched INCLUDES the following types of compensation
              </div>
            </div>
            <div class="form-unit"></div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Overtime</div>
            </div>
            <div class="form-unit">
              <roe-employer-match-overtime-radio
                :design="$v.formData"
              ></roe-employer-match-overtime-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Bonuses</div>
            </div>
            <div class="form-unit">
              <roe-employer-match-bonuses-radio
                :design="$v.formData"
              ></roe-employer-match-bonuses-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Commissions</div>
            </div>
            <div class="form-unit">
              <roe-employer-match-comissions-radio
                :design="$v.formData"
              ></roe-employer-match-comissions-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Shift Differential</div>
            </div>
            <div class="form-unit">
              <roe-employer-match-shift-differential-radio
                :design="$v.formData"
              ></roe-employer-match-shift-differential-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-small">
            <div class="form-unit">
              <div class="common-label">
                The Vesting Schedule for Employer Matching Contribution
              </div>
            </div>
            <div class="form-unit">
              <roe-vesting-select
                :design="$v.formData"
                type="match"
              ></roe-vesting-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <roe-vesting-percent-inputs
            v-if="showVestingImmediateGraded(formData)"
            class="form-row--center-small"
            :design="$v.formData"
            input-class="input-wrap--smallest"
            type="match"
          ></roe-vesting-percent-inputs>

          <roe-vesting-percent-inputs
            v-if="showVestingImmediateCliff(formData)"
            :years-count="3"
            class="form-row--center-small"
            :design="$v.formData"
            input-class="input-wrap--smallest"
            type="match"
          ></roe-vesting-percent-inputs>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import {
  InvalidFormWatcherMixin,
  EmployerMatchMixin
} from "@/components/_shared/inputs/design/_mixins";
import {
  RoeEmployerMatchSelect,
  RoeEmployerMatchAgeRequirementSelect,
  RoeEmployerMatchAgeRequirementYearsInput,
  RoeEmployerMatchAgeRequirementMonthsInput,
  RoeEmployerMatchServiceRequirementSelect,
  RoeEmployerMatchServiceRequirementMonthsInput,
  RoeEmployerMatchTypeSelect,
  RoeEmployerMatchFundingFrequencySelect,
  RoeEmployerMatchPostTaxContributionsRadio,
  RoeEmployerMatchTrueUpRadio,
  RoeEmployerMatchYosVaryEeRadio,
  RoeEmployerMatchContributionTypeSelect,
  RoeEmployerMatchContribBasedYosRadio,
  RoeEmployerMatchNumberTiersSelect,
  RoeEmployerMatchDollarLimitRadio,
  RoeEmployerMatchDollarAmountInput,
  RoeTierContributionAmountInput,
  RoeTierDeferralRateInput,
  RoeTierMatchingAmountInput,
  RoeTierYosUpperLimitInput,
  RoeTierApplicableYearInput,
  RoeEmployerMatchCatchUpRadio,
  RoeEmployerMatchEOYRequirementRadio,
  RoeEmployerMatchServiceReqAppliesInput,
  RoeEmployerMatchServiceReqAppliesSelect,
  RoeEmployerMatchTrueUpCalculateRadio,
  RoeEmployerMatchTrueUpFrequencySelect,
  RoeEmployerMatchBonusesRadio,
  RoeEmployerMatchComissionsRadio,
  RoeEmployerMatchOvertimeRadio,
  RoeEmployerMatchShiftDifferentialRadio,
  RoeVestingSelect,
  RoeVestingPercentInputs,
  RoeEmployerMatchHireDateInput
} from "@/components/_shared/inputs/design/employer-match";

export default {
  name: "RoeEmployerContributionMatchForm",
  props: ["formData"],
  mixins: [InvalidFormWatcherMixin, EmployerMatchMixin],
  validations() {
    return {
      formData: this.employerMatchValidations(this.formData)
    };
  },
  components: {
    RoeEmployerMatchHireDateInput,
    RoeTierApplicableYearInput,
    RoeEmployerMatchYosVaryEeRadio,
    RoeEmployerMatchTrueUpRadio,
    RoeEmployerMatchPostTaxContributionsRadio,
    RoeEmployerMatchSelect,
    RoeEmployerMatchAgeRequirementSelect,
    RoeEmployerMatchAgeRequirementYearsInput,
    RoeEmployerMatchAgeRequirementMonthsInput,
    RoeEmployerMatchServiceRequirementSelect,
    RoeEmployerMatchServiceRequirementMonthsInput,
    RoeEmployerMatchTypeSelect,
    RoeEmployerMatchFundingFrequencySelect,
    RoeEmployerMatchContributionTypeSelect,
    RoeEmployerMatchContribBasedYosRadio,
    RoeEmployerMatchNumberTiersSelect,
    RoeEmployerMatchDollarLimitRadio,
    RoeEmployerMatchDollarAmountInput,
    RoeTierContributionAmountInput,
    RoeTierDeferralRateInput,
    RoeTierMatchingAmountInput,
    RoeTierYosUpperLimitInput,
    RoeEmployerMatchCatchUpRadio,
    RoeEmployerMatchEOYRequirementRadio,
    RoeEmployerMatchServiceReqAppliesInput,
    RoeEmployerMatchServiceReqAppliesSelect,
    RoeEmployerMatchTrueUpCalculateRadio,
    RoeEmployerMatchTrueUpFrequencySelect,
    RoeEmployerMatchBonusesRadio,
    RoeEmployerMatchComissionsRadio,
    RoeEmployerMatchOvertimeRadio,
    RoeEmployerMatchShiftDifferentialRadio,
    RoeVestingSelect,
    RoeVestingPercentInputs
  }
};
</script>
